import { createIcon } from '../utils';

export const ReviewedIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M18 16.3333L17.1666 17.245C16.7246 17.7284 16.1251 17.9999 15.5001 17.9999C14.8751 17.9999 14.2757 17.7284 13.8337 17.245C13.391 16.7625 12.7917 16.4916 12.1668 16.4916C11.542 16.4916 10.9426 16.7625 10.5 17.245"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.86186 13.2922C3.97563 12.9964 4.03251 12.8485 4.10678 12.7102C4.17275 12.5873 4.2489 12.4701 4.33441 12.3599C4.43069 12.2358 4.54273 12.1238 4.76682 11.8997L14.1666 2.49992C15.0871 1.57945 16.5795 1.57945 17.4999 2.49993C18.4204 3.4204 18.4204 4.91279 17.4999 5.83326L8.10015 15.233C7.87606 15.4571 7.76402 15.5692 7.63995 15.6654C7.52975 15.751 7.41259 15.8271 7.28968 15.8931C7.15132 15.9673 7.00343 16.0242 6.70764 16.138L2.08325 17.9166L3.86186 13.2922Z"
        fill="currentColor"
        fillOpacity={0.16}
      />
      <path
        d="M3.79835 13.4574C3.92108 13.1383 3.98245 12.9787 4.0877 12.9057C4.17969 12.8418 4.2935 12.8176 4.4035 12.8386C4.52936 12.8627 4.65024 12.9836 4.89199 13.2253L6.77456 15.1079C7.01631 15.3496 7.13719 15.4705 7.16122 15.5964C7.18223 15.7064 7.15807 15.8202 7.09421 15.9122C7.02112 16.0174 6.86158 16.0788 6.54248 16.2015L2.08325 17.9166L3.79835 13.4574Z"
        fill="currentColor"
        fillOpacity={0.16}
      />
      <path
        d="M2.08325 17.9166L6.70764 16.138C7.00343 16.0242 7.15132 15.9673 7.28968 15.8931C7.41259 15.8271 7.52975 15.751 7.63995 15.6654C7.76402 15.5692 7.87606 15.4571 8.10015 15.233L17.4999 5.83326C18.4204 4.91279 18.4204 3.4204 17.4999 2.49993C16.5795 1.57945 15.0871 1.57945 14.1666 2.49992L4.76682 11.8997C4.54273 12.1238 4.43069 12.2358 4.33441 12.3599C4.2489 12.4701 4.17275 12.5873 4.10678 12.7102C4.03251 12.8485 3.97563 12.9964 3.86186 13.2922L2.08325 17.9166ZM2.08325 17.9166L3.79835 13.4574C3.92108 13.1383 3.98245 12.9787 4.0877 12.9057C4.17969 12.8418 4.2935 12.8176 4.4035 12.8386C4.52936 12.8627 4.65024 12.9836 4.89199 13.2253L6.77456 15.1079C7.01631 15.3496 7.13719 15.4705 7.16122 15.5964C7.18223 15.7064 7.15807 15.8202 7.09421 15.9122C7.02112 16.0174 6.86158 16.0788 6.54248 16.2015L2.08325 17.9166Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'ReviewedIcon', defaultSize: 20 },
);
